import { useQuery, useMutation, useQueryClient } from "react-query";
import apiRoutes from "../../api/apiRoutes";
import ApiCall from "../../api/network";

const fetchAllTrips = async (state, page) => {
  let tempUrl = state ? state.apiRoute : apiRoutes.getAllTrips;
  return await ApiCall.any(tempUrl, state ? state.formData : page ? page : {});
};

export const useFetchAllTrips = (state, page) => {
  return useQuery(["trips", state, page], () => fetchAllTrips(state, page), {
    staleTime: 5 * (60 * 1000),
  });
};

// get single destination

const fetchSingleTrip = async (id, isSupplierMode=false) => {
  let url = `/trip/get/${id}`
  if(isSupplierMode){
    url =  `admin/trip-preview/get/${id}`
  }
  const Route = {
    method: "GET",
    url: url,
    useAuth: true,
  };
  return await ApiCall.any(Route);
};

export const useSingleTrip = (id, isSupplierMode= false) => {
  return useQuery(["trip", id], () => fetchSingleTrip(id,isSupplierMode), {
    staleTime: 20 * (60 * 1000),
  });
};

// using mutation

// create trip
const useGetTripWithFilters = async (data) => {
  return await ApiCall.any(apiRoutes.getAllTripsWithFilters, {}, data);
};

export const useFetchWithAllFilters = () => {
  const queryClient = useQueryClient();
  return useMutation(useGetTripWithFilters, {
    onSuccess: (data) => {
      if (data.status === 1) {
        queryClient.refetchQueries("trips");
      }
    },
    onError: (_error, data, context) => {
      queryClient.refetchQueries("trips");
    },
  });
};
